import { angularDirectiveToReact } from 'Angular2reactHelper';
import { useAngularToReactRoute } from 'Angular2reactHelper/useAngularToReactRoute';
import { useLoadAdminDependencies } from 'ProtectedRoute/useLoadAdminDependencies';

const AdminMbaDirective = angularDirectiveToReact('adminMba', { section: '<' });

export function AdminMba() {
    useLoadAdminDependencies();

    const [key, params] = useAngularToReactRoute<{ section?: string }>();

    // Use key to force remount when section changes
    // angular2react doesn't update Angular scope when React props change
    return <AdminMbaDirective key={key} {...params} />;
}
